import { injectable, inject } from 'inversify';
import type { IPlanRepository, PlanFormData } from '@/domain/repositories/IPlanRepository';
import { Plan } from '@/domain/entities/Plan';
import { TYPES } from '@/di/tokens';

@injectable()
export class UpdatePlanAction {
  constructor(
    @inject(TYPES.IPlanRepository) private planRepository: IPlanRepository
  ) {}

  async execute(id: number, data: PlanFormData): Promise<Plan> {
    return await this.planRepository.update(id, data);
  }
}
